<template>
  <OurPage :title="$t('title.newNotices._')">
    <template v-if="getPermission['notice.notifications']" #header-right>
      <OurButton
        v-if="!isMobileDevice"
        :text="$t('title.fleaMarket.settingsModal')"
        @click="onClickSettingsButton"
      />
      <OurButton v-else @click="onClickSettingsButton">
        <OurSvgIcon
          class="settings-icon"
          :src="icons.Settings"
          color="white"
          variant="light"
          size="md"
        />
      </OurButton>
    </template>

    <SettingsModal :show.sync="isShownSettingsModal" />

    <NoticeList
      is-own
      :items="noticesDataOwn"
      :pagination-data="paginationDataOwn"
      :is-loading="isLoading"
      @pageChange="getOwnNoticesData"
    />
  </OurPage>
</template>

<script>
import NoticeList from "@/views/settings/new-notices/index/_components/NoticeList.vue";
import { noticesQuery } from "@/views/flea-market/index/gql/queries";
import apolloMixin from "@/mixins/apollo.mixin";
import { mapGetters } from "vuex";
import SettingsModal from "@/views/settings/new-notices/settings/Modal.vue";

export default {
  name: "NewNotices",
  components: { SettingsModal, NoticeList },
  mixins: [apolloMixin],
  data() {
    return {
      paginationDataOwn: {},
      noticesDataOwn: [],
      isShownSettingsModal: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("fleaMarket", ["getStatus", "getModerationStatus"]),
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    ...mapGetters("user", ["getPermission"]),

    icons: () => ({
      Settings: require("@material-symbols/svg-400/outlined/settings.svg"),
      DefaultImage: require("@/components/_bit/IconSvg/icons/Image.svg"),
    }),
  },
  created() {
    this.getOwnNoticesData();
  },
  methods: {
    onClickSettingsButton() {
      this.isShownSettingsModal = true;
    },
    getOwnNoticesData(page) {
      this.getData(page);
    },
    async getData(page = parseInt(this.$route.query.page) ?? 1) {
      this.isLoading = true;

      try {
        const filtersOptions = [
          {
            method: "where",
            column: "isActive",
            operator: "=",
            value: true,
          },
          {
            method: "where",
            column: "moderationStatus",
            operator: "=",
            value: "inModeration",
          },
        ];

        const { notices } = await this.$get(noticesQuery, {
          filtersOptions,
          page,
        });

        if (notices) {
          const noticesData = notices.data.map((notice) => {
            const {
              id,
              name,
              description,
              category,
              price,
              quantity,
              location,
              currency,
              files,
              isActive,
              moderationStatus,
            } = notice;
            const firstImage = files.length ? files[0].link : this.icons.DefaultImage;
            const status = this.getStatus(isActive);
            const modStatus = this.getModerationStatus(moderationStatus);

            return {
              id,
              image: firstImage,
              name: {
                primaryRow: name,
                secondaryRow: category?.description || "",
              },
              description,
              quantity: `${quantity} ${this.$t("page.fleaMarket.pieces")}`,
              location: location || "",
              price: {
                sum: price,
                currencySymbol: currency.symbol,
              },
              priceGeneral: {
                sum: price * quantity,
                currencySymbol: currency.symbol,
              },
              status,
              modStatus,
            };
          });

          this.paginationDataOwn = notices.paginatorInfo;
          this.noticesDataOwn = noticesData;
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
